import { styled } from "../../config/stiches.config";

export const Badge = styled("p", {
  fontSize: "$2",
  py: "2px",
  px: "$2",
  display: "inline-block",
  borderRadius: "$4",
  variants: {
    color: {
      lime: {
        color: "$colors$lime600",
        backgroundColor: "$colors$lime100",
      },
      purple: {
        color: "#533AAA",
        backgroundColor: "#F0EDFB",
      },
      gray: {
        color: "$colors$gray800",
        backgroundColor: "$colors$gray100",
      },
      red: {
        color: "#E62E39",
        backgroundColor: "#FFEBEC",
      },
      teal: {
        color: "$colors$teal700",
        backgroundColor: "$colors$teal100",
      },
      mango: {
        color: "#FF5722",
        backgroundColor: "#FFEFEA",
      },
      ocean: {
        color: "#1854A6",
        backgroundColor: "#EEF5FE",
      },
      sunshine: {
        color: "$colors$sunshine600",
        backgroundColor: "$colors$sunshine100",
      },
      white: {
        color: "$colors$gray900",
        backgroundColor: "White",
        border: "1px solid $colors$gray200",
      },
    },
    textSize: {
      xs: {
        fontSize: "$1",
      },
      sm: {
        fontSize: "$2",
      },
      lg: {
        fontSize: "$3",
      },
    },
    radius: {
      small: {
        borderRadius: "$2",
      }
    },
    display: {
      flex: {
        display: "flex",
      }
    }
  },
});
